var _style, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG300B4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 520,
    width: 520,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-500 -500 1020 1020",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t.number {\n\t\tfont-size:30px;\n\t\tfont-family:sans-serif;\n\t}\n\t")), /*#__PURE__*/React.createElement("g", {
    id: "G300B4",
    transform: "scale(1.0, -1.0)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 500,
    ry: 500,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 2,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 450,
    ry: 450,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 1,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 400,
    ry: 400,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 1,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 350,
    ry: 350,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "-215,-205 -215,190 215,190 215,-205",
    style: {
      fill: "#2e4a40"
    },
    stroke: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-100,189 -100,300 100,300 100,189",
    style: {
      fill: "#2e4a40"
    },
    stroke: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-215,189 -100,210 100,210 215,189 ",
    style: {
      fill: "#2e4a40"
    },
    stroke: "none"
  }), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 300,
    ry: 300,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 1,
    fillOpacity: 0
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 250,
    ry: 250,
    stroke: "lightgrey",
    strokeOpacity: 1,
    strokeWidth: 1,
    fillOpacity: 0
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 200,
    ry: 200,
    stroke: "lightgrey",
    strokeOpacity: 1,
    strokeWidth: 1,
    fillOpacity: 0
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 150,
    ry: 150,
    stroke: "lightgrey",
    strokeOpacity: 1,
    strokeWidth: 1,
    fillOpacity: 0
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 100,
    ry: 100,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 2,
    fillOpacity: 0
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 50,
    ry: 50,
    stroke: "lightgrey",
    strokeOpacity: 1,
    strokeWidth: 1,
    fillOpacity: 0
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 25,
    ry: 25,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeDasharray: " 30, 10",
    fillOpacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG300B4);
export default __webpack_public_path__ + "static/media/G300B4.5a55f3793dc817ebf9bf7a203c391994.svg";
export { ForwardRef as ReactComponent };